import styled from 'styled-components';

export const Section = styled.div`
  clear: both;
  padding: 24px 0px;
`;
